export const mockFeaturedMarkets = [
  {
    code: '1X2',
  },
  {
    code: 'UnderOver',
  },
  {
    code: 'AsianHandicap',
  },
];
export const mockFeaturedMarketsBySport = {
  soccer: [],
  tennis: [],
  'ice-hockey': [],
  handball: [],
  basketball: [],
  'american-football': [],
  volleyball: [],
  futsal: [],
  esports: [],
  squash: [],
  'table-tennis': [],
  darts: [],
  baseball: [],
  cycling: [],
  'martial-arts': [],
  motor: [],
  paddle: [],
  other: [],
  multisport: [],
};

export const mockMarketsBySport = {
  soccer: [
    '1X2',
    'Drawnobet',
    'UnderOver',
    'AsianHandicap',
    'BothTeamsToScore',
  ],
  tennis: [
    'WinASet',
    'WinAMap',
    'FistSetPlayerToBreakServe',
    'ToWinFromBehind',
    'ToWinToNil',
  ],
  'ice-hockey': [
    'DoubleChance',
    'CorrectScore',
    'TotalCorners',
    'UnderOverIncludingOvertime',
    'UnderOverRounds',
  ],
  handball: ['1X2', 'Drawnobet', 'UnderOver', 'AsianHandicap', 'DoubleChance'],
  basketball: [
    '1X2',
    'AsianHandicap',
    'DoubleChance',
    'UnderOver',
    'WinningMargin',
  ],
  'american-football': [
    '1X2',
    'AsianHandicap',
    'DoubleChance',
    'UnderOver',
    'ToWinQuarter',
  ],
  volleyball: [
    '1X2',
    'AsianHandicap',
    'DoubleChance',
    'UnderOver',
    'CorrectScore',
  ],
  futsal: [
    '1X2',
    'Drawnobet',
    'UnderOver',
    'AsianHandicap',
    'BothTeamsToScore',
  ],
  esports: ['Special', 'BetBuilder', 'OddEven', 'WillReceiveACard', 'NextGoal'],
  squash: ['1X2', 'AsianHandicap', 'DoubleChance', 'UnderOver', 'CorrectScore'],

  'table-tennis': [
    'CorrectScore',
    'AsianHandicap',
    'UnderOver',
    '1X2',
    'WinningMargin',
  ],
  darts: ['CorrectScore', 'AsianHandicap', 'UnderOver', '1X2', 'WinningMargin'],
  baseball: [
    '1X2',
    'AsianHandicap',
    'UnderOver',
    'WinningMargin',
    'CorrectScore',
  ],
  cycling: [
    'WinAMap',
    'OutrightWinner',
    'ToWinQuarter',
    'ToQualify',
    'OddEven',
  ],
  'martial-arts': [
    'WinOutright',
    'MethodOfVictory',
    'RoundBetting',
    'ToWinFight',
    'DrawNoBet',
  ],
  motor: [
    'RaceWinner',
    'PodiumFinish',
    'FastestLap',
    'PolePosition',
    'DriverMatchBets',
  ],
  paddle: [
    'MatchWinner',
    'SetWinner',
    'GameWinner',
    'CorrectScore',
    'UnderOver',
  ],
  other: [
    'Special',
    'BetBuilder',
    'ToScoreMostSixes',
    'WillAPenaltyBeAwarded',
    'WillARedCardBeShown',
  ],
  multisport: [
    'WinASet',
    'DoubleChance',
    'BothTeamsToScore',
    'HTFT',
    'TotalCorners',
  ],
};
